export class AdviseWhitelistEclairConstants {
    static readonly WHITELIST: string[] = ['MANDAT_SEPA_EC_ALERTE_OR'];
}
